const dataFields = {
  full_name: {
    name: "full_name",
    placeholder: "Digite seu nome",
    header: "Nome Completo",
    autoComplete: "name",
  },
  cpf: {
    name: "cpf",
    placeholder: "000.000.000-00",
    header: "CPF",
    maxLength: 14,
    autoComplete: "off",
  },
  email: {
    name: "email",
    type: "email",
    placeholder: "Digite seu E-mail",
    header: "E-mail",
    autoComplete: "email",
  },
  phone: {
    name: "phone",
    type: "tel",
    placeholder: "(00) 00000-0000",
    header: "Telefone",
    autoComplete: "tel",
  },
  postalCode: {
    name: "postal_code",
    type: "text",
    placeholder: "Adicione seu CEP",
    header: "CEP",
    autoComplete: "postal-code",
  },
  street: {
    name: "street",
    placeholder: "Preencha com endereço",
    header: "Endereço",
    autoComplete: "address-line1",
  },
  number: {
    name: "number",
    placeholder: "",
    header: "Número",
    autoComplete: "address-line2",
  },
  complement: {
    name: "complement",
    placeholder: "Apartamento, bloco etc. (opcional)",
    header: "Complemento",
    autoComplete: "address-line3",
  },
  neighborhood: {
    name: "neighborhood",
    placeholder: "Preencha com o Bairro",
    header: "Bairro",
    autoComplete: "address-level3",
  },
  state: {
    name: "state",
    placeholder: "Escolha seu estado",
    header: "Estado",
    autoComplete: "address-level1",
  },
  city: {
    name: "city",
    placeholder: "Adicione a sua cidade",
    header: "Cidade",
    autoComplete: "address-level2",
  },
};

export default dataFields;
